import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { login_by_admin_api } from "../DAL/Login/Login";
import { _get_is_seen_video_localStorage } from "src/DAL/localStorage/localStorage";
import { CircularProgress } from "@mui/material";
import { useContentSetting } from "src/Hooks/ContentContext/ContentSettingState";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function LoginByAdmin() {
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);

  const { handleUserInfo, START_SOCKET_FORCEFULLY } = useContentSetting();

  const handleSubmitLogin = async () => {
    setIsLoading(true);
    const data = {
      token: params.token,
      user_type: "client",
    };
    const result = await login_by_admin_api(data);
    if (result.code === 200) {
      localStorage.setItem(`user_data`, JSON.stringify(result?.member));
      localStorage.setItem(`user_data_new`, JSON.stringify(result?.member));
      localStorage.setItem("token", result?.token);
      if (result?.member?.target_weight) {
        localStorage.setItem("unit_added", true);
      }
      navigate("/dashboard", { replace: true });
      START_SOCKET_FORCEFULLY(result.member._id);
      handleUserInfo(result.member);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      navigate("/login");
    }
  };

  useEffect(() => {
    handleSubmitLogin();
  }, []);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
}
